"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jobTypeLabel = exports.sourcerJobTypes = exports.monthlyFeeJobTypes = exports.prepaymentJobTypes = exports.placementFeeJobTypes = exports.internalClientIds = void 0;
// cspell:disable
exports.internalClientIds = ['qxg2mkvw', 'wogqvlky', 'wq7deykm', 'zr7op5kb', '1j7v52k8', 'r7o445kb'];
exports.placementFeeJobTypes = ['C', 'C+$', 'CnC', 'CnC+$', 'R'];
exports.prepaymentJobTypes = ['C+$', 'CnC+$', 'R'];
exports.monthlyFeeJobTypes = ['RPO', 'S', 'SwC'];
exports.sourcerJobTypes = ['S', 'SwC'];
const jobTypeLabel = (jobType) => {
    switch (jobType) {
        case 'C':
            return 'Contingency';
        case 'C+$':
            return 'Container';
        case 'CnC':
            return 'Contingency, no calls';
        case 'CnC+$':
            return 'Container, no calls';
        case 'R':
            return 'Retained';
        case 'S':
            return 'Sourcer';
        case 'SwC':
            return 'Sourcer with calls';
        case 'Staffing':
            return 'Staffing';
        case 'RPO':
            return 'RPO';
    }
};
exports.jobTypeLabel = jobTypeLabel;
//# sourceMappingURL=job-constants.js.map